import { IShop } from "interfaces";
import cls from "./shopMiniCard.module.scss";
import FallbackImage from "components/fallbackImage/fallbackImage";
import Link from "next/link";
import { shopHref } from "utils/shopHref";

type Props = {
  data?: IShop;
  label?: string;
};

export default function ShopMiniCard({ data, label }: Props) {
  if (!data) return null; // ✅ evita errore se data è undefined
  
  return (
    <Link href={shopHref(data)} className={cls.container}>
      <div className={cls.image}>
        <FallbackImage
          fill
          sizes="60px"
          src={data?.logo_img}
          alt={data?.translation?.title}
        />
      </div>
      <div className={cls.info}>
        {!!label?.length && <span className={cls.label}>{label}</span>}
        <span className={cls.value}>{data?.translation?.title}</span>
      </div>
    </Link>
  );
}
